import axios from 'axios';
import cache from '@/services/cache';

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'https://pathfinder-ai-estq.onrender.com'
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Token expired or invalid
            cache.clear();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;